export default [
  { name: "all", label: "ทั้งหมด", color: "#e8e8e8" },
  { name: "wait", label: "รอตรวจสอบ", color: "#f2711c" },
  { name: "success", label: "ชำระเงินสำเร็จ", color: "#21ba45 " },
  { name: "fail", label: "ชำระเงินไม่สำเร็จ", color: "#db2828" },
];
